import * as React from "react";
const UsersView = React.lazy(() => import("./UsersView"));

export { UsersView };
